import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, Button, RadioGroup, FormControlLabel, MenuItem, Radio } from '@material-ui/core';
import Add from '@material-ui/icons/Add';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { BASE_URL } from '../../../store/config';
import instance from '../../../request/http';

const Root = styled(Box)({
    width: '100%',
    '& .listItem': {
        width: '100%',
        '& .itemTitle': {
            color: '#142D33',
            fontWeight: 'bold',
            marginRight: '20px',
        },
        '& .delBtn': {
            cursor: 'pointer',
            width: '30px',
            marginLeft: '10px',
            '& .del': {
                color: '#9B9B9B',
            },
        },
    },
})

const ADD = 0;
const VIEW = 1;
const EDIT = 2;
class MemberList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listData: [{
                user_id: "",
                role_id: "",
            }],
            userData: [],
        }
        this.handleAdd = this.handleAdd.bind(this);
        this.handleDelet = this.handleDelet.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
    }
    render() {
        const {
            listData,
            userData,
        } = this.state;
        const showDelBtn = (index) => {
            if (!this.isDisabled()) {
                if (index !== 0) {
                    return <div className="delBtn c" onClick={e => this.handleDelet(e, index)}>
                        <DeleteForeverIcon className="del d-e"></DeleteForeverIcon>
                    </div>
                }
            }
        }
        const showAddBtn = () => {
            if (!this.isDisabled()) {
                return <Button color="primary" onClick={this.handleAdd}>
                    <Add />ADD MORE MANAGERS
                </Button>
            }
        }
        return (
            <Root>
                {listData.map((row, index) => (
                    <div className="listItem h" key={index}>
                        <div className="itemTitle">Manager {index + 1}</div>
                        <TextField
                            disabled={this.isDisabled()}
                            select
                            label="Choose Paticipant"
                            className="f"
                            value={row.user_id}
                            onChange={e => this.handleSelect(e, index)}
                            margin="dense"
                            variant="outlined"
                        >
                            {userData.map(option => (
                                <MenuItem key={option.id} value={option.id}>
                                    {option.username} - {option.email ? option.email : "???"}
                                </MenuItem>
                            ))}
                        </TextField>
                        {showDelBtn(index)}
                    </div>
                ))}
                {showAddBtn()}
            </Root>
        )
    }
    componentDidMount() {
        this.getUsers(() => {
            this.initData();
        });
    }
    initData() {
        const { data, state } = this.props;
        if (state !== ADD) {
            if (data) {
                let listData = this.extSrcData();
                this.setState(() => ({
                    listData,
                }))
            }
        }
    }

    // 1 admin
    // 2 dept_manager
    // 3 team_leader
    // 4 billing_manager
    // 5 client_manager
    // 6 staff
    handleSelect(e, index) {
        const id = e.target.value;
        let [...listData] = this.state.listData;
        listData[index].user_id = id;
        listData[index].role_id = 2;
        console.log(listData);
        this.setState(() => ({
            listData
        }))
    }
    handleAdd() {
        let [...listData] = this.state.listData;
        let obj = {
            user_id: "",
            role_id: "",
        }
        listData.push(obj);
        this.setState(() => ({
            listData
        }));
    }
    handleDelet(e, index) {
        let [...listData] = this.state.listData;
        const obj = listData[index];
        listData.splice(index, 1);
        this.setState(() => ({
            listData
        }))
    }
    getData() {
        const { listData } = this.state;
        let arr = [];
        for (const obj of listData) {
            if (obj.user_id != "") {
                arr.push(obj);
            }
        }
        const newListData = this.filterArr(arr, "user_id");
        const srcData = this.extSrcData();
        const addMembers = this.extMember(srcData, newListData);
        const delMembers = this.extMember(newListData, srcData);
        return { addMembers, delMembers };
    }
    extSrcData() {
        const { data } = this.props;
        let listData = [];
        for (const userObj of data) {
            let obj = {};
            obj.user_id = userObj.id;
            obj.role_id = 2;
            listData.push(obj);
        }
        return listData;
    }
    extMember(list1, list2) {
        let result = [];
        for (const obj2 of list2) {
            let userId2 = obj2.user_id;
            let isExist = false;
            for (const obj1 of list1) {
                let userId1 = obj1.user_id;
                if (userId1 === userId2) {
                    isExist = true;
                    break;
                }
            }
            if (!isExist) {
                result.push(obj2);
            }
        }
        return result;
    }
    //对象数组去重
    filterArr(objArr, key) {
        const newMap = new Map();
        const deduplicationObjArr = objArr.filter((obj) => !newMap.has(obj[key]) && newMap.set(obj[key], 1));
        return deduplicationObjArr
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }

    //----------------request-------------------------------
    getUsers(callback) {
        let params = {
            page_index: 1,
            page_size: 100
        }
        instance.get(BASE_URL + 'users', { params }).then((res) => {
            let userData = res.data.data
            console.log(userData)
            this.setState({
                userData
            }, () => {
                callback();
            });
        })
    }

}

export default MemberList;